export function moneyize(number){
  return  `${number < 0 ? '-' : ''}$${Number(Math.abs(number)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
}

export default moneyize